import { useAppSelector } from "../redux/store";
import Routes from "../Routes";

export default function useAllowedRoutes() {
  const user = useAppSelector((state) => state.database.user);
  const allowed = Routes.filter((a) => a.role.includes(user?.role || "user"));

  return allowed;
}
